export enum TrayFormViewModelType {
  // CXB
  //TODO: delete this monster, use new enum from backend (TrayTypeApiModel)
  //TODO: ask for enum from backend, to map types to display names
  ContinueWatchingCarousel = 'Continue watching tray', // BuiltInTypeApiModel.ContinueWatchingCarousel (CXB)
  WatchlistCarousel = 'Watchlist tray', // BuiltInTypeApiModel.WatchlistCarousel (CXB)
  PortraitTray = 'Portrait Tray',
  TopTenTray = 'Top10 Tray',
  ExpandableTray = 'Expandable Tray',
  GenreTray = 'Genre/Category Tray',
  StudiosTray = 'Studios Tray',
  HeroTray = 'Hero carousel', // AXB-980
  CTA = 'Cta',
  USP = 'Usp',
  TRENDING = 'Marketing Trending',
  STUDIO = 'Studio',
  KIDS = 'Kids',
  EMAIL = 'Email Collector',
  TopPicks = 'Top Picks', // AXB-1061
  TopPicksMovies = 'Top Picks Movies', // AXB-1062
  TopPicksSeries = 'Top Picks Series', // AXB-924
  BecauseYouWatched = 'Because You Watched', // AXB-925
  BecauseYouWatchGenreTray = 'Because You Watched Genre', // AXB-932
  PeopleLikeYouWatch = 'People Like You Watch', // AXB-926
  PeopleLikeYouWatchMovies = 'People Like You Watch Movies', // AXB-927
  PeopleLikeYouWatchSeries = 'People Like You Watch Series', // AXB-928
  Trending = 'Reco Trending', // AXB-929
  TrendingMovies = 'Reco Trending (movies)', // AXB-930
  TrendingSeries = 'Reco Trending (series)', // AXB-931
  TrendingWithLayout = 'Trending', // AXB-929
  DontMiss = 'Dont Miss', // AXB-933
  MarketingHero = 'Marketing hero', // AXB-1138
  DetailedPageMarketingBanner = 'Detailed page marketing banner', // AXB-1132
  RedeemGenericVoucherTray = 'Redeem Generic Voucher Tray',
  RedeemPartnerVoucherTray = 'Redeem Partner Voucher Tray', // AXB-948
  RedeemCtaTray = 'Redeem Cta Tray',
  RedeemUspTray = 'Redeem Usp Tray', // AXB-970
  FaqTray = 'FAQ tray', // AXB-975
  AppLandingMobileTray = 'App Landing Mobile',
  AppLandingCotvTray = 'App Landing Cotv',
  CollectionTray = 'Collection Tray',
  SpotlightTray = 'Spotlight Tray',
  SeasonTray = 'Season Tray',
  SinglePhotoSeasonTray = 'OnDemand Season Tray',
  MarketingEmailBlocker = 'Email Blocker',
  DeviceModuleTray = 'Device Module Tray',
  // UXB
  ContentTray = 'Content Tray',
  MarketingBannerTray = 'Marketing banner', // AXB-330
  MarketingBarTray = 'Marketing bar',
  MarketingVideoTray = 'Marketing Video Tray',
  MyFavouritesOnLiveTV = 'Favourite channels', // AXB-71
  AppsAndGames = 'Apps & Games', // AXB-70
  RecentlyWatchedTV = 'Recently Watched TV', // AXB-77
  LiveTVReminders = 'Live TV reminders', // AXB-84
  TopTenOnOSNPlusPosterArt = 'Top 10 OSN+', // AXB-82
  TVGuide = 'TV Guide', // AXB-78
  TitleImagePortraitTray = 'Google apps', // 'Title Image Portrait Tray', // AXB-89
  HeroSpotlightTray = 'Hero (Spotlight)', // AXB-67, AXB-68
  MyListTray = 'My list', // AXB-80 // BuiltInTypeApiModel.Watchlist (UXB)
  ContinueWatchingTray = 'Continue watching', // AXB-79 // BuiltInTypeApiModel.ContinueWatching (UXB)
  CarouselBannerTray = 'Landscape posters with banner', // AXB-88 old name: Carousel banner
  StreamingContentTray = 'Streaming Content tray', // AXB-81
  UpcomingOnSpecificTvChannelTray = 'Upcoming on TV channel', // AXB-83
  ComingSoonForLiveTvTray = 'Coming Soon on TV', //AXB-74
  TopTenOnLiveTvTray = 'Top 10 on Live TV', //AXB-75
  CurrentlyOnTvTray = 'Currently on TV', // AXB-73
  ChannelLogoTray = 'TV channels logo tray', // AXB-76
  FullscreenTray = 'Banners only', // AXB-72 old name: Banner 5
  BannersTrayWithCta = 'Portrait posters', //AXB-86 old name: Banners Tray With Cta
  SearchTagsTray = 'Search Tags', //AXB-172
  BannersThree = 'Landscape posters', // AXB-87 old name: Banner 3-3
  RecommendedChannelsTray = 'Recommended Channels', //AXB-194
  TopPicksDownloadable = 'Top Picks - Downloadable',
  TopPicksMoviesDownloadable = 'Top Picks Movies - Downloadable',
  TopPicksSeriesDownloadable = 'Top Picks Series - Downloadable',
  PeopleLikeYouWatchDownloadable = 'People Like You Watch - Downloadable',
  PeopleLikeYouWatchMoviesDownloadable = 'People Like You Watch Movies - Downloadable',
  PeopleLikeYouWatchSeriesDownloadable = 'People Like You Watch Series - Downloadable',
  MostDownloadedMovies = 'Most downloaded movies',
  MostDownloadedSeries = 'Most downloaded series',
  Editorial = 'Editorial',
  CatchUpTray = 'Catch-up', //AXB-1353,
  ChannelSpecificCatchUpTray = 'Channel specific catch-up', //AXB-1354
  LandscapeTray = 'Landscape Tray',
  WatchlistOnDemandTray = 'OnDemand My list',
  PrimeVideoRecommendationsTray = 'Prime Video Recommendations',
  OndemandCategoryTray = 'Category Tray',
  OndemandBannerTray = 'OnDemand Banner',
  ContinueWatchingOndemandTray = 'Continue Watching OnDemand', //MYX-86
  RecentlyPurchasedTray = 'Recently purchased',
  MixedSearchTagTray = 'Mixed Search Tags',
  ExpiringStoreContents = 'Expiring in 48 hours',
}
